import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class ReportRunSlackMessageModel extends ModeModelBase {
  override _name = 'reportRunSlackMessage';
  override belongsTo = 'reportRun';
  override parentIdAttribute = 'token';
  override attributes = [
    { name: 'channel', default: '' },
    { name: 'channel_id', default: '' },
    { name: 'message', default: '' },
    { name: 'csv_attachments_enabled', default: true },
    { name: 'pdf_attachments_enabled', default: false },
    { name: 'data_previews_enabled', default: false },
  ];
}

@Injectable({ providedIn: 'root' })
export class ReportRunSlackMessageModelAccessor extends ModelAccessorBase<ReportRunSlackMessageModel> {
  override name = 'reportRunSlackMessage';
  override parentModel = 'reportRun';
  override parentIdAttribute = 'token';

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.reportRunSlackMessage');
  }

  createModel(resource, opts?) {
    const model = new ReportRunSlackMessageModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
